<script setup lang="ts">
  import { provide, toRef, type Component } from 'vue'
  import {
    modalStackEntryTopKey,
    modalStackEntryZKey,
    type ModalParams
  } from '../../lib/modal-stack'

  // Renders one stack entry and provides its z (and whether it's the stack top)
  // to descendants, so the inner Modal takes z from the stack index instead of
  // the global counter and renders non-modal under the central host. A
  // dedicated component is required because `provide` is per-instance — the host
  // can't provide a different context per entry from its own setup.
  const props = defineProps<{
    component: Component
    params: ModalParams
    zIndex: number
    isTop: boolean
  }>()

  provide(modalStackEntryZKey, toRef(props, 'zIndex'))
  provide(modalStackEntryTopKey, toRef(props, 'isTop'))
</script>
<template>
  <component :is="component" v-bind="params" />
</template>
